import { __assign, __rest } from "tslib";
import React from 'react';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import InternalTable from './internal';
import useBaseComponent from '../internal/hooks/use-base-component';
var Table = React.forwardRef(function (_a, ref) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, _c = _a.selectedItems, selectedItems = _c === void 0 ? [] : _c, props = __rest(_a, ["items", "selectedItems"]);
    var baseComponentProps = useBaseComponent('Table');
    return React.createElement(InternalTable, __assign({ items: items, selectedItems: selectedItems }, props, baseComponentProps, { ref: ref }));
});
applyDisplayName(Table, 'Table');
export default Table;
//# sourceMappingURL=index.js.map